/**
 * VELUNA — JavaScript principal
 * Fonctions : cookie banner RGPD, menu mobile, AJAX cart, galerie
 */

const veluna = (() => {

  /* ---- COOKIE BANNER ---- */
  const initCookieBanner = () => {
    const banner = document.getElementById('cookie-banner');
    if (!banner) return;

    const consent = localStorage.getItem('veluna_cookie_consent');
    if (!consent) {
      // Afficher la bannière après 500ms
      setTimeout(() => banner.classList.add('is-visible'), 500);
    }

    document.getElementById('cookie-accept')?.addEventListener('click', () => {
      localStorage.setItem('veluna_cookie_consent', 'accepted');
      localStorage.setItem('veluna_cookie_date', new Date().toISOString());
      banner.classList.remove('is-visible');
      // Ici : activer GA4, Meta Pixel si consentement donné
      enableAnalytics();
    });

    document.getElementById('cookie-refuse')?.addEventListener('click', () => {
      localStorage.setItem('veluna_cookie_consent', 'refused');
      localStorage.setItem('veluna_cookie_date', new Date().toISOString());
      banner.classList.remove('is-visible');
    });
  };

  const enableAnalytics = () => {
    console.log('[VELUNA] Analytics activés avec consentement.');
  };

  /* ---- MENU MOBILE ---- */
  const initMobileMenu = () => {
    const toggle = document.getElementById('mobile-menu-toggle');
    const nav = document.getElementById('mobile-nav');
    if (!toggle || !nav) return;

    toggle.addEventListener('click', () => {
      const isOpen = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen.toString());
      nav.setAttribute('aria-hidden', (!isOpen).toString());
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });

    document.addEventListener('click', (e) => {
      if (!toggle.contains(e.target) && !nav.contains(e.target)) {
        nav.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        nav.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
    });
  };

  /* ---- CART COUNT UPDATE ---- */
  const updateCartCount = async () => {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const els = document.querySelectorAll('#cart-count, #cart-count-mobile');
      els.forEach(el => {
        el.textContent = cart.item_count > 0 ? cart.item_count : '';
        el.setAttribute('data-count', cart.item_count);
      });
    } catch (e) {
      // Silently fail
    }
  };

  /* ---- AJAX ADD TO CART ---- */
  const addToCart = async (variantId, buttonEl) => {
    if (!variantId) return;

    const originalText = buttonEl?.textContent;
    if (buttonEl) {
      buttonEl.textContent = 'Ajout…';
      buttonEl.disabled = true;
    }

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });

      if (!res.ok) throw new Error('Erreur ajout panier');

      await updateCartCount();
      showCartNotification();

      if (buttonEl) {
        buttonEl.textContent = '✓ Ajouté !';
        setTimeout(() => {
          buttonEl.textContent = originalText;
          buttonEl.disabled = false;
        }, 2000);
      }
    } catch (err) {
      console.error('[VELUNA] Erreur addToCart:', err);
      if (buttonEl) {
        buttonEl.textContent = 'Erreur — Réessayez';
        buttonEl.disabled = false;
      }
    }
  };

  /* ---- NOTIFICATION PANIER ---- */
  const showCartNotification = () => {
    let notif = document.getElementById('cart-notification');
    if (!notif) {
      notif = document.createElement('div');
      notif.id = 'cart-notification';
      notif.style.cssText = `
        position: fixed; top: 80px; right: 1.5rem; z-index: 9998;
        background: #1C1C1C; color: #fff; padding: 0.875rem 1.25rem;
        border-radius: 6px; font-family: 'Jost', sans-serif; font-size: 0.875rem;
        box-shadow: 0 4px 20px rgba(0,0,0,0.2);
        transform: translateX(120%); transition: transform 0.3s ease;
        display: flex; align-items: center; gap: 0.75rem;
      `;
      document.body.appendChild(notif);
    }
    notif.innerHTML = `
      ✓ Produit ajouté au panier
      <a href="/cart" style="color: #B8965A; text-decoration: underline; margin-left: 0.5rem;">Voir le panier</a>
    `;
    requestAnimationFrame(() => {
      notif.style.transform = 'translateX(0)';
    });
    setTimeout(() => {
      notif.style.transform = 'translateX(120%)';
    }, 3500);
  };

  /* ---- PRODUCT FORM (page produit) ---- */
  const initProductForm = () => {
    const forms = document.querySelectorAll('.product-form');
    if (!forms.length) return;

    forms.forEach(form => {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const submitBtn = form.querySelector('[type="submit"]');
        // Sélecteur robuste : cible le champ caché "id" du formulaire produit,
        // quel que soit l'ID généré (ex: variant-id-{{ product.id }}).
        const variantInput = form.querySelector('input[name="id"]');
        const variantId = variantInput?.value;
        if (variantId) {
          await addToCart(parseInt(variantId), submitBtn);
        } else {
          console.error('[VELUNA] Impossible de trouver le variant ID dans le formulaire produit.');
        }
      });
    });
  };

  /* ---- ANIMATIONS SCROLL ---- */
  const initScrollAnimations = () => {
    if (!('IntersectionObserver' in window)) return;

    const cards = document.querySelectorAll('.product-card');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry, i) => {
        if (entry.isIntersecting) {
          entry.target.style.animationDelay = `${i * 0.05}s`;
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    cards.forEach(card => observer.observe(card));
  };

  /* ---- INIT ---- */
  const init = () => {
    initCookieBanner();
    initMobileMenu();
    initProductForm();
    initScrollAnimations();
    updateCartCount();
  };

  document.addEventListener('DOMContentLoaded', init);

  // Exposer les méthodes publiques
  return { addToCart, updateCartCount };

})();
